import { createAction } from '@reduxjs/toolkit';

const resetSearch = createAction('archive/resetSearch');

export default resetSearch;
